import styled from "styled-components";


export const BaseComp = styled.div`
    display: flex;
    flex-direction: column;
    @media only screen and (max-width: 800px) {
        flex-direction: column;
    }

`;

export const BaseContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    @media (max-width: 1000px) {
        margin: 0% 1%;
    }
`;

export const TextContent = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

`;

export const TextTitle = styled.div`
font-family: 'Montserrat', sans-serif;;
    h1 {
        font-size: 36px;
        color: white;
        font-family: 'Montserrat', sans-serif;;
    }
    @media (max-width: 1000px) {
        h1 {
            font-size: 30px;
        }
    }
    h2 {
        font-weight: normal;
    }
`;

export const TextBody = styled.div`
    font-size: 24px;
    p {
        margin-top: 3%;
    }
`;

export const IconsContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5% 0;
    @media only screen and (max-width: 800px) {
        flex-direction: column;
    }
`;

export const DefaultBox = styled.div`
    width: 220px;
    height: 220px;
    margin: 10px;
    color: var(--orange);
    font-weight: bold;
    font-family: 'Montserrat', sans-serif;;
    h1 {
        font-family: 'Montserrat', sans-serif;
        color: var(--orange);
        font-size: 3.2rem;
    }
    padding: 1% 2%;
    border-radius: 16px;
    justify-content: center;
    text-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const IconImg = styled.img`
    width: 120px;
    height: auto;
`;
export const IconImgMulti = styled.img`
    width: 120px;
    height: auto;
`;

export const BannerContent = styled.div`
    position: relative;
    width: 100%;
    height: 450px;  /* ou a altura que deseja */
    overflow: hidden;
`;

export const BannerImg = styled.img`
  width: 100%;
  height: 120%;        /* maior que o container para dar profundidade */
  object-fit: cover;
`;